<template>
  <div class="rgi-box">
    <DetectIPComponent :show="showDect" @emitShowDect="showDectMeth"></DetectIPComponent>
    <div class="d-flex align-items-center calc-height">
      <CContainer>
        <CRow class="justify-content-center" style="">
          <CCol md="12" style="">
            <CCardGroup style="">
              <CCard class="p-4" style="min-height:800px;position:relative;">
                <div class="drop-box">
                  <el-dropdown
                    @command="changeLanguage"
                    style="vertical-align: middle !important"
                  >
                    <span class="el-dropdown-link">
                      <!-- {{ locales }}<i class="el-icon-arrow-down el-icon--right"></i> -->
                      <!-- <svg viewBox="64 64 896 896" data-icon="global" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"></path></svg> -->
                      <img v-if="locales=='繁體'" style="vertical-align:-1px;margin-right:2px" src="@/assets/media/zh_HK.png" /><img v-else style="vertical-align:-1px;margin-right:2px" src="@/assets/media/en_GB.png" />{{ locales }}
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="tw"><span style="margin-right:2px"><img style="vertical-align:-1px" src="@/assets/media/zh_HK.png" /></span>繁體</el-dropdown-item>
                      <el-dropdown-item command="en"><span style="margin-right:2px"><img style="vertical-align:-1px" src="@/assets/media/en_GB.png" /></span>English</el-dropdown-item>
                      <!-- <el-dropdown-item command="zh">简体</el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <CCardBody id="formboxc" style="flex:1 1 420px;display:flex;flex-direction:column;justify-content:center;padding-top:0!important;padding-bottom:0!important;">
                  <!-- <div style="padding:0 20px;">
                    <div class="logobox-flex">
                      <img src="@/assets/logo32.webp" alt="">
                      <h3>Fotoncard</h3>
                    </div>
                    <div class="logobox-kohao">
                      <h2>{{ $t('LoginFields.SecurePayGlobalWay') }}</h2>
                    </div>
                  </div> -->
                  <div>
                    <div class="logo-container">
                        <div class="logod">
                            <img style="width:100%;height:100%;" src="@/assets/login/lg.png" alt="">
                        </div>
                        <div class="logo-text">Foton Card</div>
                    </div>
                    <div style="text-align:center;">
                      <div class="slogan" :style="locales == 'EN'?'font-size:11px':''">{{ $t('LoginFields.SecurePayGlobalWay') }}</div>
                    </div>
                  </div>
                  <!-- <div class="titlebox-h2title">
                    <h2>登錄您的賬戶</h2>
                    <div class="titlebox-tabbox">
                      <div class="tabt">郵箱</div>
                    </div>
                  </div> -->
                  <CForm class="form-box">
                    <div class="return-icon">
                      <svg
                        @click="toLogin"
                        style="margin-bottom: 0.2rem"
                        height="35"
                        width="35"
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-xxl"
                        viewBox="0 0 512 512"
                        role="img"
                      >
                        undefined
                        <path
                          fill="var(--ci-primary-color, currentColor)"
                          d="M256,16.042c-132.548,0-240,107.451-240,240s107.452,240,240,240,240-107.452,240-240S388.548,16.042,256,16.042ZM403.078,403.12A207.253,207.253,0,1,1,447.667,337,207.364,207.364,0,0,1,403.078,403.12Z"
                          class="ci-primary"
                        ></path>
                        <polygon
                          fill="var(--ci-primary-color, currentColor)"
                          points="272.614 164.987 249.986 142.36 136.305 256.041 249.986 369.722 272.614 347.095 197.56 272.041 385 272.041 385 240.041 197.56 240.041 272.614 164.987"
                          class="ci-primary"
                        ></polygon>
                      </svg>
                      <h3 style="margin-left: 1rem">
                        {{ $t("RegisterFields.CreateAccount") }}
                      </h3>
                    </div>

                    <p class="text-muted">
                      {{ $t("RegisterFields.CreateTip") }}
                    </p>
                    <!-- <CInput
                  placeholder="Username"
                  autocomplete="username"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput> -->

                    <CInput
                      ref="registerEmailInput"
                      id="register-email-input"
                      class="register-email-field"
                      type="email"
                      name="email"
                      v-model="rForm.email"
                      :invalid-feedback="errorBackEmail"
                      :is-valid="validatorEmail"
                      valid-feedback=""
                      :placeholder="$t('RegisterFields.PlaceholderEmail')"
                      autocomplete="email"
                      prepend="@"
                      @input="handleRegisterEmailInput"
                      @change="handleRegisterEmailInput"
                    />

                    <div class="ac-input row g-3">
                      <CCol md="8" sm="6" style="padding-right: 0">
                        <CInput
                          :placeholder="
                            $t('RegisterFields.PlaceholderEmailCode')
                          "
                          autocomplete="username"
                          v-model="rForm.code"
                        >
                          <template #prepend-content
                            ><CIcon name="cil-shield-alt"
                          /></template>
                        </CInput>
                      </CCol>
                      <CCol md="4">
                        <div>
                          <CButton
                            id="register-send-code-btn"
                            color="success"
                            style="margin-bottom: 1rem;padding:10px 0.75rem;"
                            block
                            :disabled="isSendCodeDisabled"
                            @click="handleRegisterSendCodeClick"
                            >{{ cgan == "" ? getVc : cgan }}</CButton
                          >
                        </div>
                      </CCol>
                    </div>
                    <div id="register-captcha-element"></div>
                    <CInput
                      :placeholder="$t('RegisterFields.PlacehoderPassword')"
                      type="password"
                      autocomplete="new-password"
                      v-model="rForm.password"
                      :invalid-feedback="errorBackPassword"
                      :is-valid="validatorPassword"
                      valid-feedback=""
                    >
                      <template #prepend-content
                        ><CIcon name="cil-lock-locked"
                      /></template>
                      
                    </CInput>

                    <CInput
                      :placeholder="
                        $t('RegisterFields.PlacehoderConfirmPassword')
                      "
                      type="password"
                      autocomplete="new-password"
                      class="mb-4"
                      v-model="rForm.cPassword"
                      :invalid-feedback="errorBackConfirm"
                      :is-valid="validatorConfirm"
                      valid-feedback=""
                    >
                      <template #prepend-content
                        ><CIcon name="cil-lock-locked"
                      /></template>
                    </CInput>

                    <CInput
                      :placeholder="$t('RegisterFields.InvitationCode')"
                      type="text"
                      class="mb-4"
                      v-model="rForm.invite"
                      :disabled="iscode"
                      :invalid-feedback="errorBackInvite"
                      :is-valid="validatorInvite"
                      valid-feedback=""
                    >
                      <template #prepend-content
                        ><CIcon name="cilUser"
                      /></template>
                    </CInput>
                    <div>
                      <el-checkbox v-model="checked"
                        >{{ $t("RegisterFields.Accept") }}
                        <a
                          href="https://dashboard.fotoncard.com/PrivacyPolicy.pdf"
                          target="_blank"
                          >{{ $t("RegisterFields.PrivacyPolicyand") }}</a
                        >
                        <span>{{ $t("RegisterFields.And") }}</span>
                        <a
                          href="https://dashboard.fotoncard.com/CookiePolicy.pdf"
                          target="_blank"
                          >{{ $t("RegisterFields.CookiePolicy") }}</a
                        >
                      </el-checkbox>
                    </div>
                    <CButton
                      :disabled="isCreateDisabled"
                      class="form-btnbg"
                      block
                      @click="register"
                      >{{ $t("RegisterFields.Submit") }}</CButton
                    >
                  </CForm>
                  <div class="media-box" style="margin-bottom:0">
                    <div class="mb-item">
                      <a href="https://www.facebook.com/fotoncard" target="_blank">
                        <img style="width:23px;height:23px;" src="@/assets/media/facebook2.svg" alt="">
                      </a>
                    </div>
                    <div class="mb-item">
                      <a target="_blank" href="https://www.instagram.com/fotoncard_official?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">
                        <img style="width:23px;height:23px;" src="@/assets/media/instagram2.svg" alt="">
                      </a>
                    </div>
                    <div class="mb-item">
                      <a href="https://t.me/FotonCardCS" target="_blank">
                        <img style="width:23px;height:23px;" src="@/assets/media/telegram2.svg" alt="">
                      </a>
                    </div>
                    <div class="mb-item">
                      <a href="https://www.youtube.com/@FotonCard.Official" target="_blank">
                        <img style="width:26px;height:26px;" src="@/assets/media/youtube2.svg" alt="">
                      </a>
                    </div>
                  </div>
                </CCardBody>
                <!-- <CCardFooter class="p-4">
              <CRow>
                <CCol col="6">
                  <CButton block color="facebook">
                    Facebook
                  </CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="twitter">
                    Twitter
                  </CButton>
                </CCol>
              </CRow>
            </CCardFooter> -->
              </CCard>
              <!-- 右邊區域 -->
              <CCard
                text-color="white"
                class="text-center d-md-down-none custom-bgc"
                body-wrapper
                style="padding: 1.25rem;min-height:800px;background-image:linear-gradient(90deg,#f5f6f8,#fff)"
              >
                <CCardBody style="height:100%;flex:1 1 500px">
                  <div class="features-section" style="flex-direction:column;display:flex;justify-content:center;padding:0 50px;background-image:linear-gradient(90deg,#f5f6f8,#fff)">
                    <div class="feature">
                        <div class="feature-icon">
                            
                            <img style="width:70px;height:70px;" class="feature-webp" src="@/assets/login/real.webp" alt="">
                        </div>
                        <div class="feature-content">
                            <h3>{{ $t('LoginFields.RealTimeDepositWithdrawalTitle') }}</h3>
                            <p>{{ $t('LoginFields.RealTimeDepositWithdrawalDesc') }}</p>
                        </div>
                    </div>
                    
                    <div class="feature">
                        <div class="feature-icon">
                            <img style="width:70px;height:70px;" class="feature-webp" src="@/assets/login/auth.webp" alt="">
                        </div>
                        <div class="feature-content">
                            <h3>{{ $t('LoginFields.BankLevelSecuritySystemTitle') }}</h3>
                            <p>{{ $t('LoginFields.BankLevelSecuritySystemDesc') }}</p>
                        </div>
                    </div>
                    
                    <div class="feature">
                        <div class="feature-icon">
                            <img style="width:70px;height:70px;" class="feature-webp" src="@/assets/login/kf.webp" alt="">
                        </div>
                        <div class="feature-content">
                            <h3>{{ $t('LoginFields.CustomerServiceTitle') }}</h3>
                            <p>{{ $t('LoginFields.CustomerServiceDesc') }}</p>
                        </div>
                    </div>
                    
                    <div class="feature">
                        <div class="feature-icon">
                            <img style="width:70px;height:70px;" class="feature-webp" src="@/assets/login/card.webp" alt="">
                        </div>
                        <div class="feature-content">
                            <h3>{{ $t('LoginFields.ZeroHiddenFeeTitle') }}</h3>
                            <p>{{ $t('LoginFields.ZeroHiddenFeeDesc') }}</p>
                        </div>
                    </div>
                    
                    <div class="feature">
                        <div class="feature-icon">
                            <img style="width:70px;height:70px;" class="feature-webp" src="@/assets/login/world.webp" alt="">
                        </div>
                        <div class="feature-content">
                            <h3>{{ $t('LoginFields.GlobalMultiRegionCardBINsTitle') }}</h3>
                            <p>{{ $t('LoginFields.GlobalMultiRegionCardBINsDesc') }}</p>
                        </div>
                    </div>
                    
                    <div class="feature">
                        <div class="feature-icon">
                            <img style="width:70px;height:70px;" class="feature-webp" src="@/assets/login/user.webp" alt="">
                        </div>
                        <div class="feature-content">
                            <h3>{{ $t('LoginFields.TrustedByOverGlobalUsersTitle') }}</h3>
                            <p>{{ $t('LoginFields.TrustedByOverGlobalUsersDesc') }}</p>
                        </div>
                    </div>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
    <CFooter :fixed="true" style="justify-content: center; padding: 0 !important">
    
        <div style="display:flex;flex-direction: column;text-align:center;">
          <div style="padding-bottom: 5px">
            Copyright © 2020 ~ 2026 Foton Card All rights reserved
          </div>
        </div>
    </CFooter>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { mapMutations } from "vuex";
import { changeLanguages } from "../../api/http";
import DetectIPComponent from '@/components/DetectIPComponent.vue'
import posthog from '../../plugins/posthog'
import { register as registerWithNewService, sendRegisterVerificationCode } from '@/api/cardAuthService'
import captchaLogoImg from '@/assets/calogo.png'
import {
  getBrowserFingerprintsMd5,
  initAliyunCaptcha,
  isAliyunCaptchaConfigured,
  resetAliyunCaptcha
} from '@/utils/aliyunCaptcha'

export default {
  name: "Register",
  components: { DetectIPComponent },
  data() {
    return {
      // vcode: "发送验证码",
      rcode: "重新发送",
      dib: true,
      isCodeCountingDown: false,
      timer: null,
      timerNum: 30,
      errorBackEmail: "",
      errorBackConfirm: "",
      errorBackInvite: "",
      errorBackPassword: "",
      rForm: {
        email: "",
        password: "",
        cPassword: "",
        code: "",
        invite: "",
      },
      is200: false,
      validError: false,
      validNice: true,
      cgan: "",
      checked: false,
      iscode: false,
      isReg: true,
      showDect: false,
      registerCaptchaInstance: null,
      registerCaptchaPromise: null,
      registerCaptchaReady: false,
      registerCaptchaInitializing: false,
      registerCaptchaPendingOpen: false,
      registerCaptchaAutoOpening: false,
      lastRegisterEmail: "",
      // getVc: ""
      // rDis: true
    };
  },
  computed: {
    vcode: {
      get() {
        return this.$t("RegisterFields.SendCode2");
      },
      set(val) {
        console.log(val);
        // this.getVc = val
      },
    },
    getVc: {
      get() {
        return this.$t("RegisterFields.SendCode2");
      },
      set(v) {
        console.log("vvv==>", v);
        this.cgan = v;
      },
    },
    isSendCodeDisabled() {
      return this.isCodeCountingDown ||
        this.registerCaptchaAutoOpening ||
        this.registerCaptchaPendingOpen ||
        !this.isRegisterEmailValid(this.rForm.email);
    },
    // 国际化切换显示对应文字
    locales() {
      let language = localStorage.getItem("admin_lang");
      if (language == "TC") {
        this.$i18n.locale == "tw";
        return "繁體";
      } else if (language == "EN") {
        this.$i18n.locale == "en";
        return "EN";
      } else {
        this.$i18n.locale == "en";
        return "EN";
      }
      // if (this.$i18n.locale == "tw") {
      //   return "繁体";
      // } else if (this.$i18n.locale == "zh") {
      //   return "中文";
      // } else {
      //   return "EN";
      // }
    },
    isPasswordFormatValid() {
      return this.isPasswordValidValue(this.rForm.password);
    },
    isConfirmPasswordValid() {
      return !!this.rForm.cPassword && this.rForm.cPassword === this.rForm.password;
    },
    isCreateDisabled() {
      return !this.isRegisterEmailValid(this.rForm.email) || !this.isPasswordFormatValid || !this.isConfirmPasswordValid;
    },
  },
  created() {
    this.rForm.email = "";
    this.lastRegisterEmail = "";
    localStorage.setItem("agent", this.$route.query.agent);
    // window.sessionStorage.setItem('agent', this.$route.query.agent)
    if (this.$route.query.agent == undefined) {
      this.rForm.invite = "";
      this.iscode = false;
    } else {
      this.rForm.invite = this.$route.query.agent;
      localStorage.setItem("agent", this.$route.query.agent);
      this.$store.state.agentp = this.$route.query.agent;
      this.iscode = true;
    }
    this.detectIPLocation()
  },
  mounted() {
    posthog.capture('register_page_view', {
      page_name: 'Register',
      page_path: this.$route.fullPath,
      agent_code: this.$route.query.agent || ''
    })
    this.$nextTick(() => {
      setTimeout(() => {
        this.syncAutofilledEmail()
      }, 300)
      setTimeout(() => {
        this.syncAutofilledEmail()
      }, 1000)
    })
  },
  watch: {
    $route(to, from) {
      console.log("to", to);
      console.log("from", from);
    },
    'rForm.email'(email, oldEmail) {
      if (email !== oldEmail) {
        this.resetRegisterCaptchaByEmailChange()
      }
    }
  },
  methods: {
    // 返回登录页
    toLogin() {
      this.$router.push("/pages/login");
    },
    showDectMeth() {
      this.showDect = false
    },
    detectIPLocation() {
      this.$axios({
        method: "GET",
        url: "https://ipapi.co/json/",
      }).then(res => {
        // console.log("res", res)
        if(res.data.country === 'CN') {
          // this.$router.push("/pages/detect-ip")
          this.showDect = true
        }
      }).catch(error => {
        console.log("IP检测失败", error)
      })
    },
    // 获取cookie
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    // 写入cookie
    setCookie(name, value) {
      var Days = 30;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie =
        name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    },
    // 随机数
    randomString(e) {
      e = e || 24;
      var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456789",
        a = t.length,
        n = "";
      for (i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
      return n;
    },
    ...mapMutations(["setUserInfo"]),
    // 驗證密碼只能為數字和英文最低六位
    isPasswordValidValue(val) {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      return !!val && reg.test(val);
    },
    handleRegisterEmailInput(value) {
      if (value && value.target) {
        this.rForm.email = value.target.value;
        this.lastRegisterEmail = value.target.value;
        return;
      }

      if (typeof value === 'string') {
        this.rForm.email = value;
        this.lastRegisterEmail = value;
      }
    },
    // 獲取郵箱輸入框元素
    getRegisterEmailInputElement() {
      const idInput = document.getElementById('register-email-input');
      if (idInput && idInput.tagName === 'INPUT') return idInput;
      if (idInput && idInput.querySelector) {
        const nestedInput = idInput.querySelector('input');
        if (nestedInput) return nestedInput;
      }

      const fieldInput = this.$el && this.$el.querySelector('.register-email-field input');
      if (fieldInput) return fieldInput;

      const refInput = this.$refs.registerEmailInput &&
        this.$refs.registerEmailInput.$el &&
        this.$refs.registerEmailInput.$el.querySelector('input');
      if (refInput) return refInput;

      return this.$el && this.$el.querySelector('input[name="email"], input[autocomplete="email"], input[type="email"]');
    },
    // 實時同步郵箱
    syncAutofilledEmail() {
      const emailInput = this.getRegisterEmailInputElement();

      if (emailInput && emailInput.value !== this.rForm.email) {
        this.rForm.email = emailInput.value;
      }

      this.lastRegisterEmail = emailInput ? emailInput.value : this.rForm.email;
      return this.lastRegisterEmail;
    },
    // 初始化人機驗證
    prepareRegisterCaptcha() {
      if (!isAliyunCaptchaConfigured()) return Promise.resolve()
      if (this.registerCaptchaReady) return Promise.resolve(this.registerCaptchaInstance)
      if (this.registerCaptchaPromise) return this.registerCaptchaPromise

      this.registerCaptchaInitializing = true
      this.registerCaptchaPromise = initAliyunCaptcha({
        element: '#register-captcha-element',
        button: '#register-send-code-btn',
        language: this.getCaptchaLanguage(),
        captchaLogoImg,
        // 业务请求(带验证码校验)回调函数
        captchaVerifyCallback: this.handleRegisterCaptchaVerify,
        // 业务请求结果回调函数
        onBizResultCallback: this.handleRegisterCaptchaBizResult,
        fail: this.handleRegisterCaptchaFail,
        // 绑定验证码实例函数
        getInstance: (instance) => {
          this.registerCaptchaInstance = instance
          this.registerCaptchaReady = true
        }
      }).then((instance) => {
        return instance
      }).catch((error) => {
        console.log('阿里云人机验证初始化失败', error)
        return Promise.reject(error)
      }).finally(() => {
        this.registerCaptchaInitializing = false
        this.registerCaptchaPromise = null
      })

      return this.registerCaptchaPromise
    },
    getCaptchaLanguage() {
      return this.$i18n.locale === 'tw' ? 'tw' : 'en'
    },
    getRegisterCaptchaOptions() {
      return {
        element: '#register-captcha-element',
        button: '#register-send-code-btn'
      }
    },
    // 重置人機驗證
    resetRegisterCaptchaByEmailChange() {
      this.registerCaptchaPendingOpen = false
      this.is200 = false

      if (!this.registerCaptchaInstance) return

      const refreshed = resetAliyunCaptcha(
        this.getRegisterCaptchaOptions(),
        this.registerCaptchaInstance
      )

      if (!refreshed) {
        this.registerCaptchaInstance = null
        this.registerCaptchaReady = false
        this.registerCaptchaPromise = null
        this.registerCaptchaInitializing = false
      }
    },
    // 獲取當前語言
    getRegisterLanguage() {
      return this.$i18n.locale === 'tw' ? 'TC' : 'EN'
    },
    // 驗證郵箱是否符合
    isRegisterEmailValid(email) {
      const reg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!email || !reg.test(email)) {
        return false
      }

      const domain = email.substring(email.indexOf('@') + 1)
      return domain !== 'yahoo.com'
    },
    // 兼容接口返回的中英文message
    getResponseMessage(response, fallback = '') {
      if (!response) {
        return fallback
      }

      if (typeof response === 'string') {
        return response
      }

      if (typeof response === 'object') {
        const langKey = this.$i18n.locale === 'tw' ? 'tc' : 'en'
        const message = response.message || response.data || response

        if (typeof message === 'string') {
          return message || fallback
        }

        if (message && typeof message === 'object') {
          return message[langKey] || message.en || message.tc || fallback
        }
      }

      return fallback
    },
    // 觸發阿里雲人機驗證
    handleRegisterCaptchaVerify(captchaVerifyParam) {
      const email = this.syncAutofilledEmail()
      if (!this.validatorEmail(email)) {
        this.$message.error(this.errorBackEmail || this.$t("RegisterFields.CETip"))
        return Promise.resolve({
          captchaResult: true,
          bizResult: false
        })
      }

      return this.sendRegisterCodeWithCaptcha(captchaVerifyParam).then((result) => {
        return {
          captchaResult: result.captchaResult,
          bizResult: result.bizResult
        }
      })
    },
    handleRegisterCaptchaBizResult(bizResult) {
      if (bizResult === false) {
        this.is200 = false
      }
    },
    handleRegisterCaptchaFail(error) {
      console.log('阿里云人机验证失败', error)
    },
    // 點擊發送驗證碼按鈕
    handleRegisterSendCodeClick() {
      if (this.registerCaptchaAutoOpening) return

      const email = this.syncAutofilledEmail()
      if (!this.validatorEmail(email)) {
        this.$message.error(this.errorBackEmail || this.$t("RegisterFields.CETip"))
        return
      }

      if (!isAliyunCaptchaConfigured()) {
        this.reqCode()
        return
      }

      this.registerCaptchaPendingOpen = true
      if (this.registerCaptchaReady) {
        this.openRegisterCaptcha(this.registerCaptchaInstance)
        this.registerCaptchaPendingOpen = false
        return
      }

      this.prepareRegisterCaptcha().then((instance) => {
        if (this.registerCaptchaPendingOpen) {
          this.openRegisterCaptcha(instance)
        }
      }).catch(() => {
        this.$message.error('Captcha is loading. Please try again later.')
      }).finally(() => {
        this.registerCaptchaPendingOpen = false
      })
    },
    // 顯示阿里雲人機驗證
    openRegisterCaptcha(instance = this.registerCaptchaInstance) {
      instance.refresh()
      const openMethod = ['show', 'showCaptcha', 'open'].find((method) => {
        return instance && typeof instance[method] === 'function'
      })

      if (openMethod) {
        instance[openMethod]()
        return
      }

      const button = document.querySelector('#register-send-code-btn')
      if (!button) return

      this.registerCaptchaAutoOpening = true
      this.$nextTick(() => {
        button.click()
        this.registerCaptchaAutoOpening = false
      })
    },
    // 發送注冊驗證碼
    sendRegisterCodeWithCaptcha(captchaVerifyParam) {
      const email = this.syncAutofilledEmail()
      const payload = {
        email,
        captchaVerifyParam,
        fingerprintsMd5: getBrowserFingerprintsMd5()
      }

      return sendRegisterVerificationCode(payload).then((res) => {
        const responseMessage = this.getResponseMessage(res)

        if (res.code == 200) {
          this.$message.success(responseMessage)
          this.is200 = true
          this.cellCode()
          return {
            captchaResult: true,
            bizResult: true
          }
        }

        this.timerNum = 30
        this.isCodeCountingDown = false
        this.cgan = ""
        clearInterval(this.timer)
        this.$message.error(responseMessage)
        this.is200 = false
        return {
          captchaResult: false,
          bizResult: false
        }
      }).catch((error) => {
        this.timerNum = 30
        this.isCodeCountingDown = false
        this.cgan = ""
        clearInterval(this.timer)
        this.$message.error(error.message || 'Send verification code failed')
        this.is200 = false
        return {
          captchaResult: false,
          bizResult: false
        }
      })
    },
    // 请求验证码 （舊的驗證碼接口，已廢棄）
    reqCode() {
      let loading = Loading.service({ fullscreen: true });
      let data = {
        type: "get_email_code",
        user_name: this.rForm.email,
      };
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: process.env.VUE_APP_BASE_URL+"/request/user.php",
        data: formData,
      }).then((code) => {
        if (code.data.code == 200) {
          loading.close();
          this.$message.success(code.data.message);
          this.is200 = true;
          this.cellCode();
        } else {
          this.timerNum = 30;
          this.isCodeCountingDown = false;
          this.cgan = "";
          clearInterval(this.timer);
          this.$message.error(code.data.message);
          loading.close();
          this.is200 = false;
        }
      });
    },
    // 获取语言并且设置语言
    changeLanguage(e) {
      let str = "";
      if (e == "tw") {
        str = e.replace(e, "TC");
      } else {
        str = e.replace(e, "EN");
      }
      console.log("lange==>", str);
      let obj = {
        type: "change_language",
        lan: str,
      };
      changeLanguages(obj).then((res) => {
        // console.log("lange res==>", res)
        if (res.code == 200) {
          window.localStorage.setItem("admin_lang", e == "tw" ? "TC" : "EN");
          this.$i18n.locale = e;
          // window.location.reload();
        } else {
          this.$message.error(res.message);
        }
      });
      // let str = ""
      // if(e == "tw") {
      //   str = e.replace(e, "TC")
      // }else {
      //   str = e.replace(e, "EN")
      // }
      // console.log('lange==>', str)
      // let obj = {
      //   type: "change_language",
      //   lan: str
      // }
      // changeLanguages(obj).then((res) => {
      //   // console.log("lange res==>", res)
      //   if(res.code == 200) {
      //     window.localStorage.setItem("lang", e);
      //     this.$i18n.locale = e;
      //     window.location.reload()
      //   }else{
      //     this.$message.error(res.message)
      //   }
      // })
      // location.reload();
      // window.localStorage.setItem("lang", e);
      // this.$i18n.locale = e;
    },
    // 请求验证码倒计时
    cellCode() {
      // this.reqCode()
      this.dib = true;
      clearInterval(this.timer);
      this.timerNum = 30;
      this.isCodeCountingDown = true;
      this.getVc = this.timerNum;
      this.timer = setInterval(() => {
        this.timerNum--;
        // this.vcode = this.timerNum
        this.getVc = this.timerNum;
        // this.$t('RegisterFields.SendCode2') = this.timerNum
        if (this.timerNum == 0) {
          clearInterval(this.timer);
          // this.vcode = this.rcode
          //  this.vcode = this.$t('RegisterFields.SendCode')
          this.vcode = this.getVc;
          this.timerNum = 30;
          this.cgan = "";
          this.isCodeCountingDown = false;
          this.dib = false;
        }
      }, 1000);
    },
    validatorInvite(val) {
      console.log(1);
    },
    // 验证邮箱
    validatorEmail(val) {
      // let reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
      let reg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (val === "") {
        this.errorBackEmail = "";
        this.isReg = true;
        this.dib = true;
        return;
      }
      let index = val.indexOf("@");
      let res = val.substr(index + 1, val.length);
      console.log("str res==>", res);
      if (res == "yahoo.com") {
        this.errorBackEmail = this.$t("RegisterFields.YahooTip");
        this.dib = true;
        this.isReg = true;
        return false;
      }
      if (reg.test(val)) {
        this.errorBackEmail = "";
        this.dib = false;
        this.isReg = false;
        return true;
      } else {
        this.errorBackEmail = this.$t("RegisterFields.CETip");
        this.dib = true;
        this.isReg = true;
        return false;
      }
    },
    // 验证确认密码
    validatorConfirm(val) {
      if (val === "") {
        this.errorBackEmail = "";
        this.isReg = true;
        return;
      }
      if (val !== this.rForm.password) {
        this.errorBackConfirm = this.$t("RegisterFields.CRPTip");
        this.isReg = true;
        return (this.validNice = false);
      }
      this.errorBackEmail = "";
      this.isReg = false;
      return (this.validNice = true);
    },
    // 密码验证
    validatorPassword(val) {
      if (val === "") {
        this.errorBackPassword = "";
        return;
      }
      if (this.isPasswordValidValue(val)) {
        this.errorBackPassword = "";
        return true;
      } else {
        this.errorBackPassword = this.$t("RegisterFields.PasswordTip");
        return false;
      }
    },
    // 提交注冊接口
    submitRegisterWithNewService(loading) {
      const payload = {
        email: this.rForm.email,
        password: this.rForm.password,
        confirmPassword: this.rForm.cPassword,
        verificationCode: this.rForm.code,
        invitationCode: this.rForm.invite,
        language: this.getRegisterLanguage(),
        fingerprintsMd5: getBrowserFingerprintsMd5()
      }

      registerWithNewService(payload).then((res) => {
        const responseMessage = this.getResponseMessage(res)

        if (res.code == 200) {

          // 只有註冊接口明確成功後才發送 Google Ads 轉換；
          // 統計不可用時不影響原有註冊成功流程。
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'conversion', {
              send_to: 'AW-17286132874/ESe8CLan3t8cEIrp1bJA'
            })
          }

          // 只有註冊接口明確成功後才發送 Meta Pixel 註冊完成事件；
          // Pixel 不可用時不影響原有註冊成功流程。
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'CompleteRegistration')
          }

          // 采集用户注册成功
          posthog.capture('register_success', {
            agent_code: this.rForm.invite || this.$route.query.agent || '',
            email: this.rForm.email
          })

          this.$message.success(responseMessage)
          loading.close()
          if (res.data) {
            this.setUserInfo(res.data)
          }
          this.$router.push("/pages/login")
        } else {
          loading.close()
          this.rDis = true
          this.$message.error(responseMessage)
        }
      }).catch((error) => {
        loading.close()
        this.rDis = true
        this.$message.error(this.getResponseMessage(error && error.response && error.response.data, error.message || 'Register failed'))
      })
    },
    // 舊的注冊接口，已廢棄
    registerWithLegacyService(loading) {
      let data = {
        type: "register",
        user_name: this.rForm.email,
        email_code: this.rForm.code,
        password: this.rForm.password,
        agent_code: this.rForm.invite,
        login_cookie: this.getCookie("ckey"),
      };
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: process.env.VUE_APP_BASE_URL+"/request/user.php",
        data: formData,
      }).then((code) => {
        if (code.data.code == 200) {
          // 发送Google转化
          // gtag('event', 'conversion', {
          //   send_to: 'AW-17286132874/J5soCI_ijL8cEIrp1bJA',
          //   value: 1.0,
          //   currency: 'USD'
          // });
          // 采集用户注册成功
          posthog.capture('register_success', {
            agent_code: this.rForm.invite || this.$route.query.agent || '',
            email: this.rForm.email
          })


          this.$message.success(code.data.message);
          loading.close();
          this.setUserInfo(code.data.data);
          this.$router.push("/pages/login");
        } else {
          loading.close();
          this.rDis = true;
          this.$message.error(code.data.message);
        }
      });
    },
    // 注册
    register() {
      this.syncAutofilledEmail()

      if (
        this.rForm.email == "" ||
        this.rForm.cPassword == "" ||
        this.rForm.password == "" ||
        this.rForm.code == "" ||
        this.rForm.invite == "" ||
        this.checked == false
      ) {
        this.$message.error(this.$t("RegisterFields.None"));
        return;
      }
      if (this.isPasswordFormatValid && this.isConfirmPasswordValid && this.validNice == true) {
        this.rDis = false;
        let loading = Loading.service({ fullscreen: true });
        this.submitRegisterWithNewService(loading);
      } else {
        this.$message.error("校验失败");
      }
    },
  },
};
</script>
<style>
.aliyunCaptcha-checkbox-logo {
  transform: scale(1.3);
}
</style>
<style scoped>
@import "../../assets/css/login.css";
.return-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 0.5rem;
}

/* .ac-input{
    display: flex;
    justify-content: space-between;
  }
  .form-group:nth-child(2) {
    width: 77%;
  } */
.ac-input {
  flex-wrap: nowrap;
}
.form-box {
  padding: 20px;
}
.drop-box {
  display: flex;
  justify-content: end;
  align-content: center;
  /* margin-right: 2rem; */
  /* margin-top: 1rem; */
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 10;
}
</style>
